// extracted by mini-css-extract-plugin
export default {"refreshTime":"tracking-page-refreshTime-GyCH3j"};